var React = require('react');

function Sc (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M0 0h682.7v512H0z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","transform":"scale(.9375)","key":1},[React.createElement("path",{"fill":"red","d":"M0 0h992.1v512H0z","key":0}),React.createElement("path",{"fill":"#090","d":"M0 512l992.1-170.7V512H0z","key":1}),React.createElement("path",{"fill":"#fff","d":"M0 512l992.1-341.3v170.6L0 512z","key":2}),React.createElement("path",{"fill":"#009","d":"M0 512V0h330.7L0 512z","key":3}),React.createElement("path",{"fill":"#ff0","d":"M0 512L330.7 0h330.7L0 512z","key":4})])]);
}

Sc.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Sc;

Sc.default = Sc;
